(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("react-select"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "react-select", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["Auth0LockPlayground"] = factory(require("react"), require("prop-types"), require("react-select"), require("lodash"));
	else
		root["Auth0LockPlayground"] = factory(root["react"], root["prop-types"], root["react-select"], root["lodash"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_43__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition


// WEBPACK FOOTER //
// webpack:///webpack/universalModuleDefinition